import { useEffect } from 'react'
import { useThemeStore } from '../store/useThemeStore'
import { resolveSystemTheme } from '../utils/themeUtils'

export function useTheme() {
  const { theme, setTheme } = useThemeStore()

  useEffect(() => {
    const resolved = theme === 'system' ? resolveSystemTheme() : theme
    document.documentElement.setAttribute('data-theme', resolved)

    // Listen for system preference changes when in system mode
    if (theme !== 'system') return

    const darkQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const contrastQuery = window.matchMedia('(prefers-contrast: more)')

    const update = () => {
      document.documentElement.setAttribute('data-theme', resolveSystemTheme())
    }

    darkQuery.addEventListener('change', update)
    contrastQuery.addEventListener('change', update)

    return () => {
      darkQuery.removeEventListener('change', update)
      contrastQuery.removeEventListener('change', update)
    }
  }, [theme])

  return { theme, setTheme }
}
